import React from 'react';

const ReportHeader = ({ loanData, calculationDate }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    // Parse date properly to avoid timezone issues
    let date;
    if (typeof dateString === 'string') {
      if (dateString?.includes('T')) {
        date = new Date(dateString.split('T')[0] + 'T12:00:00.000Z');
      } else if (dateString?.includes('-')) {
        const dateParts = dateString?.split('-');
        date = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), 12, 0, 0);
      } else {
        date = new Date(dateString + 'T12:00:00.000Z');
      }
    } else {
      date = new Date(dateString);
    }
    
    return date?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="text-center mb-8 print:mb-6">
      <h1 className="text-3xl font-bold text-gray-900 print:text-2xl mb-2">Loan Amortization Schedule</h1>
      {loanData?.loanDescription && (
        <h2 className="text-xl font-semibold text-blue-600 print:text-lg mb-2">
          {loanData?.loanDescription}
        </h2>
      )}
      {!loanData?.loanDescription && (
        <h2 className="text-xl font-semibold text-gray-600 print:text-lg mb-2">
          Loan Calculation Report
        </h2>
      )}
      
      {/* Loan Date Display */}
      {(loanData?.loanClosingDate || loanData?.loanDate) && (
        <div className="text-lg text-gray-700 print:text-base mb-3">
          <span className="font-medium">Loan Date: </span>
          <span className="font-semibold">
            {formatDate(loanData?.loanClosingDate || loanData?.loanDate)}
          </span>
        </div>
      )}
    </div>
  );
};

export default ReportHeader;